export function formatHTML(value) {
  return `&euro;&nbsp;${value.toString().replace('.', ',')}`;
}
